export default __webpack_public_path__ + "static/media/webtorrent.0c41ddec.svg";